import { Instance } from 'mobx-state-tree';
import { UserInviteCreatedDtoModelBase } from './UserInviteCreatedDtoModel.base';

/* The TypeScript type of an instance of UserInviteCreatedDtoModel */
export interface UserInviteCreatedDtoModelType extends Instance<typeof UserInviteCreatedDtoModel.Type> {}

/* A graphql query fragment builders for UserInviteCreatedDtoModel */
export { selectFromUserInviteCreatedDto, userInviteCreatedDtoModelPrimitives, UserInviteCreatedDtoModelSelector } from './UserInviteCreatedDtoModel.base';

/**
 * UserInviteCreatedDtoModel
 */
export const UserInviteCreatedDtoModel = UserInviteCreatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
